import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/site-chrome";

export const Route = createFileRoute("/tentang")({
  head: () => ({
    meta: [
      { title: "Tentang Kami — jasasebar.com" },
      { name: "description", content: "Kenali jasasebar.com, papan promosi jasa berperingkat untuk pelaku usaha kecil Indonesia." },
      { property: "og:title", content: "Tentang Kami — jasasebar.com" },
      { property: "og:description", content: "Misi dan cara kerja jasasebar.com untuk membantu UMKM Indonesia dipromosikan." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://jasasebar.com/tentang" }],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main className="mx-auto max-w-3xl space-y-6 px-4 py-12 text-sm leading-relaxed">
        <h1 className="font-display text-3xl font-semibold">Tentang jasasebar.com</h1>
        <p>
          jasasebar.com adalah papan promosi berperingkat untuk jasa dan produk Indonesia. Kami percaya pelaku usaha
          kecil, seperti fotografer lepas, penjahit, guru les, atau toko online rumahan, layak mendapat panggung yang
          sama dengan bisnis besar.
        </p>
        <h2 className="font-display text-xl font-semibold">Misi kami</h2>
        <p>
          Membuat promosi online jadi sederhana dan transparan. Siapa pun bisa mendaftar gratis, dan semua orang bisa
          melihat posisi serta jumlah klik setiap listing secara terbuka.
        </p>
        <h2 className="font-display text-xl font-semibold">Apa yang kami lakukan</h2>
        <ul className="list-disc space-y-1 pl-5">
          <li>Memoderasi setiap listing sebelum tampil agar papan bebas penipuan dan konten terlarang.</li>
          <li>Menghitung klik unik secara jujur, satu orang satu kali per hari.</li>
          <li>Menerbitkan panduan promosi dan pemasaran digital di <Link to="/blog" className="underline">blog</Link> kami.</li>
          <li>Memproses pembayaran lewat payment gateway resmi dengan invoice untuk setiap transaksi.</li>
        </ul>
        <h2 className="font-display text-xl font-semibold">Hubungi kami</h2>
        <p>
          Ada pertanyaan, saran, atau laporan listing? Kunjungi halaman <Link to="/kontak" className="underline">Kontak</Link>.
        </p>
      </main>
      <SiteFooter />
    </div>
  );
}
